<template>
  <div class="modal fade" id="map-options-dialog" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-white rounded-4">
        <div class="modal-header border-0 px-4 pt-3">
          <h5 class="modal-title"><strong>{{ $t('map_options_dialog.options') }}</strong></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" :aria-label="$t('shared.close')"></button>
        </div>
        <div class="modal-body p-0">
          <ul class="list-group list-group-flush">
            <li v-if="showEditDetails" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('edit-details')">
              <span>{{ $t('shared.edit_details') }}</span>
              <span class="material-icons">edit</span>
            </li>
            <li v-if="editHike" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('edit')">
              <span>{{ $t('map_options_dialog.open_route_in_planner') }}</span>
              <span class="material-icons">edit_location</span>
            </li>
            <li v-if="showCreate" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('create')">
              <span>{{ $t('map_options_dialog.plan_a_hike') }}</span>
              <span class="material-icons">add_location</span>
            </li>
            <li v-if="showWaypoints" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('waypoints')">
              <span>{{ $t('map_options_dialog.waypoints') }}</span>
              <span class="material-icons">add_location_alt</span>
            </li>
            <li v-if="showGoTo" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('goto')">
              <span>{{ $t('map_options_dialog.go_to_location') }}</span>
              <span class="material-icons">my_location</span>
            </li>
            <li v-if="showFlyover" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('flyover')">
              <span>{{ $t('shared.3d_flyover') }}</span>
              <span class="material-icons">play_arrow</span>
            </li>
            <li v-if="showReportIssue" class="list-group-item text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('report-issue')">
              <span>{{ $t('map_options_dialog.report_an_issue') }}</span>
              <span class="material-icons">flag</span>
            </li>
          </ul>
          <div v-if="showMeasurement || showPrint" style="background: rgba(255,255,255,.04)">
            <div v-if="showMeasurement || showPrint" class="d-flex align-items-center mb-0 px-4 pt-3">
              <span class="badge bg-info text-dark me-2">{{ $t('shared.pro') }}</span>
            </div>
            <ul class="list-group list-group-flush">
              <li v-if="showMeasurement" class="list-group-item bg-transparent text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('measurement')">
                <span class="d-flex align-items-center"><span class="me-2 rounded-circle d-inline-block" style="width:8px;height:8px;background:#34c8ff"></span>{{ $t('map_options_dialog.measurement_tool') }}</span>
                <span class="material-icons">straighten</span>
              </li>
              <li v-if="showPrint" class="list-group-item bg-transparent text-white d-flex justify-content-between align-items-center px-4 py-3" @click="emitAndClose('print')">
                <span class="d-flex align-items-center"><span class="me-2 rounded-circle d-inline-block" style="width:8px;height:8px;background:#34c8ff"></span>{{ $t('map_options_dialog.print_hike_map') }}</span>
                <span class="material-icons">print</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  </template>

<script setup>
import { Modal } from 'bootstrap'

// Define props to control which options are visible
const props = defineProps({
  showEditDetails: {
    type: Boolean,
    default: false
  },
  editHike: {
    type: Boolean,
    default: true
  },
  showCreate: {
    type: Boolean,
    default: true
  },
  showWaypoints: {
    type: Boolean,
    default: true
  },
  showGoTo: {
    type: Boolean,
    default: true
  },
  showFlyover: {
    type: Boolean,
    default: false
  },
  showMeasurement: {
    type: Boolean,
    default: true
  },
  showPrint: {
    type: Boolean,
    default: true
  },
  showReportIssue: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['edit-details','edit','create','reverse','waypoints','goto','flyover','measurement','print','report-issue'])

function emitAndClose(evt){
  const el = document.getElementById('map-options-dialog');
  if (el) Modal.getOrCreateInstance(el).hide();
  emit(evt)
}

function open(){
  const el = document.getElementById('map-options-dialog');
  if (el) Modal.getOrCreateInstance(el).show();
}
defineExpose({ open })
</script>

<style scoped>

.list-group-item{
  border-bottom: 1px solid #434343;
  cursor: pointer;
}

.list-group-item:hover{
    opacity: 80%;
  }
</style>
